import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from '@mui/material';
import { useEffect, useReducer } from 'react';
import { CreatePageHeader } from '@/Components/Headers';
import { Label } from '@/Components/ui/label';
import { Input } from '@/Components/ui/input';
import config from './gstDetailsConfig';
import { inputHelper } from '@/Helpers';

const LabelledInput = (props) => {
	const {
		value, onChange, id, name, placeholder, labelText, mandatory, type = 'text',
	} = props;
	return (
		<div className='flex items-center gap-2'>
			<Label
				className={`${mandatory ? 'text-red-600' : ''} text-left min-w-[150px]`}
				htmlFor={id}
			>
				{mandatory ? `${labelText}*` : labelText}
			</Label>
			<Input
				id={id}
				type={type}
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
			/>
			{/* <TextField
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                sx={{
                    '.MuiInputBase-root': {
                        borderRadius: '12px',
                    },
                    '.MuiInputBase-input': {
                        paddingTop: '6px',
                        paddingBottom: '6px',
                    },
                }}
            /> */}
		</div>
	);
};
function GstDetails() {
	const isEdit = false;
	const history = useHistory();
	const location = useLocation();
	// const params = useParams();
	const { gstData } = location?.state || {};
	const [data, dispatch] = useReducer(config?.reducer, config?.initialState);
	const {
		userName,
		legalName,
		password,
		gstNum,
		email,
		phone,
		address1,
		city,
		state,
		pincode,
		address2,
	} = data;
	const handleSubmit = () => {
		// eslint-disable-next-line no-unused-vars
		const valid = config?.validator(state);
		// if (valid) {
		// console.log('save');
		// }
	};
	const renderBtns = () => {
		return (
			<Button onClick={handleSubmit}>Save</Button>
		);
	};
	const handleBackClick = () => {
		history.goBack();
	};
	const handleInput = (e) => {
		const { fieldName, fieldValue } = inputHelper(e);
		return dispatch({
			type: 'SET_VALUE',
			payload: {
				[fieldName]: fieldValue,
			},
		});
	};
	const fetchData = (gst) => {
		return dispatch({
			type: 'SET_VALUE',
			payload: {
				userName: gst?.userName,
				legalName: gst?.userName,
				password: gst?.userName,
				gstNum: gst?.userName,
				email: gst?.userName,
				phone: gst?.userName,
				address1: gst?.userName,
				city: gst?.userName,
				state: gst?.userName,
				pincode: gst?.userName,
				address2: gst?.userName,
			},
		});
	};
	useEffect(() => {
		if (gstData) {
			fetchData(gstData);
		}
	}, [gstData]);
	return (
		<div>
			<CreatePageHeader
				handleSubmit={handleSubmit}
				showCancel={false}
				heading={`${isEdit ? 'Edit' : 'Create'} Gst Deatils`}
				renderBtns={renderBtns}
				showBack
				handleBackClick={handleBackClick}
			/>
			<div className='w-[70%] p-5 flex flex-col gap-3'>
				<LabelledInput
					id='userName'
					name='userName'
					value={userName}
					onChange={handleInput}
					placeholder='Enter UserName'
					labelText='User Name'
				/>
				<LabelledInput
					mandatory
					id='legalName'
					name='legalName'
					value={legalName}
					onChange={handleInput}
					placeholder='Enter Legal Name'
					labelText='Legal Name'
				/>
				<LabelledInput
					id='password'
					type='password'
					name='password'
					value={password}
					onChange={handleInput}
					placeholder='Enter Password'
					labelText='Password'
				/>
				<LabelledInput
					mandatory
					id='gstNum'
					name='gstNum'
					value={gstNum}
					onChange={handleInput}
					placeholder='Enter GST Number'
					labelText='GST Number'
				/>
				<LabelledInput
					id='email'
					type='email'
					name='email'
					value={email}
					onChange={handleInput}
					placeholder='Enter email'
					labelText='Email'
				/>
				<LabelledInput
					id='phone'
					type='number'
					name='phone'
					value={phone}
					onChange={handleInput}
					placeholder='Enter Phone Number'
					labelText='Phone Number'
				/>
				<LabelledInput
					mandatory
					id='address1'
					type='text'
					name='address1'
					value={address1}
					onChange={handleInput}
					placeholder='Enter Address  Line '
					labelText='Billing Adress 1'
				/>
				<LabelledInput
					mandatory
					id='address2'
					type='text'
					name='address2'
					value={address2}
					onChange={handleInput}
					placeholder='Enter Address  Line '
					labelText='Billing Address 2'
				/>
				<LabelledInput
					mandatory
					id='city'
					type='text'
					name='city'
					value={city}
					onChange={handleInput}
					placeholder='Enter City'
					labelText='City'
				/>
				<LabelledInput
					mandatory
					id='state'
					type='state'
					name='state'
					value={state}
					onChange={handleInput}
					placeholder='Enter State'
					labelText='State'
				/>
				<LabelledInput
					mandatory
					id='pincode'
					type='number'
					value={pincode}
					onChange={handleInput}
					name='pincode'
					placeholder='Enter Pincode'
					labelText='Pincode'
				/>
			</div>
		</div>
	);
}

export default GstDetails;
